const bankOpportunityTranslations = {
  en: {
    navigation: "Bank & Distressed",
    title: "Bank & Distressed Opportunities",
    subtitle: "Verified bank-owned, distressed and special-situation investment opportunities.",
    add: "Add opportunity",
    search: "Search by title, bank, reference or city…",
    allStatuses: "All statuses",
    allSources: "All sources",
    total: "Total opportunities",
    published: "Published",
    verified: "Verified",
    protected: "Commission protected",
    price: "Price",
    priceUponRequest: "Price upon request",
    deadline: "Deadline",
    source: "Source",
    location: "Location",
    discount: "Estimated discount",
    verification: "Verification",
    commission: "Commission",
    noResults: "No bank or distressed opportunities found.",
    notice: "Internal investment intelligence. Verify all facts before external distribution.",
  },
  pt: {
    navigation: "Banca e Distressed",
    title: "Oportunidades Bancárias e Distressed",
    subtitle: "Oportunidades de investimento bancárias, distressed e situações especiais verificadas.",
    add: "Adicionar oportunidade",
    search: "Pesquisar por título, banco, referência ou cidade…",
    allStatuses: "Todos os estados",
    allSources: "Todas as fontes",
    total: "Total de oportunidades",
    published: "Publicadas",
    verified: "Verificadas",
    protected: "Comissão protegida",
    price: "Preço",
    priceUponRequest: "Preço sob consulta",
    deadline: "Prazo",
    source: "Fonte",
    location: "Localização",
    discount: "Desconto estimado",
    verification: "Verificação",
    commission: "Comissão",
    noResults: "Não foram encontradas oportunidades bancárias ou distressed.",
    notice: "Inteligência de investimento interna. Verificar todos os factos antes da divulgação externa.",
  },
  zh: {
    navigation: "银行与困境资产",
    title: "银行与困境资产机会",
    subtitle: "经核实的银行持有、困境资产及特殊情形投资机会。",
    add: "添加机会",
    search: "按标题、银行、编号或城市搜索…",
    allStatuses: "全部状态",
    allSources: "全部来源",
    total: "机会总数",
    published: "已发布",
    verified: "已核实",
    protected: "佣金已保障",
    price: "价格",
    priceUponRequest: "价格面议",
    deadline: "截止日期",
    source: "来源",
    location: "位置",
    discount: "预计折扣",
    verification: "核实状态",
    commission: "佣金",
    noResults: "未找到银行或困境资产机会。",
    notice: "内部投资情报。对外发布前须核实所有事实。",
  },
  fr: {
    navigation: "Banque & Distressed",
    title: "Opportunités bancaires et distressed",
    subtitle: "Opportunités d’investissement bancaires, distressed et situations spéciales vérifiées.",
    add: "Ajouter une opportunité",
    search: "Rechercher par titre, banque, référence ou ville…",
    allStatuses: "Tous les statuts",
    allSources: "Toutes les sources",
    total: "Total des opportunités",
    published: "Publiées",
    verified: "Vérifiées",
    protected: "Commission protégée",
    price: "Prix",
    priceUponRequest: "Prix sur demande",
    deadline: "Échéance",
    source: "Source",
    location: "Localisation",
    discount: "Décote estimée",
    verification: "Vérification",
    commission: "Commission",
    noResults: "Aucune opportunité bancaire ou distressed trouvée.",
    notice: "Intelligence d’investissement interne. Vérifier tous les faits avant diffusion externe.",
  },
  es: {
    navigation: "Banca y Distressed",
    title: "Oportunidades bancarias y distressed",
    subtitle: "Oportunidades de inversión bancarias, distressed y situaciones especiales verificadas.",
    add: "Añadir oportunidad",
    search: "Buscar por título, banco, referencia o ciudad…",
    allStatuses: "Todos los estados",
    allSources: "Todas las fuentes",
    total: "Total de oportunidades",
    published: "Publicadas",
    verified: "Verificadas",
    protected: "Comisión protegida",
    price: "Precio",
    priceUponRequest: "Precio a consultar",
    deadline: "Plazo",
    source: "Fuente",
    location: "Ubicación",
    discount: "Descuento estimado",
    verification: "Verificación",
    commission: "Comisión",
    noResults: "No se encontraron oportunidades bancarias o distressed.",
    notice: "Inteligencia de inversión interna. Verificar todos los datos antes de su difusión externa.",
  },
  de: {
    navigation: "Bank & Distressed",
    title: "Bank- und Distressed-Opportunitäten",
    subtitle: "Verifizierte bankeigene, notleidende und besondere Investitionsmöglichkeiten.",
    add: "Opportunität hinzufügen",
    search: "Nach Titel, Bank, Referenz oder Stadt suchen…",
    allStatuses: "Alle Status",
    allSources: "Alle Quellen",
    total: "Opportunitäten gesamt",
    published: "Veröffentlicht",
    verified: "Verifiziert",
    protected: "Provision geschützt",
    price: "Preis",
    priceUponRequest: "Preis auf Anfrage",
    deadline: "Frist",
    source: "Quelle",
    location: "Standort",
    discount: "Geschätzter Abschlag",
    verification: "Verifizierung",
    commission: "Provision",
    noResults: "Keine Bank- oder Distressed-Opportunitäten gefunden.",
    notice: "Interne Investmentinformationen. Alle Fakten vor externer Weitergabe prüfen.",
  },
  it: {
    navigation: "Banche e Distressed",
    title: "Opportunità bancarie e distressed",
    subtitle: "Opportunità d’investimento bancarie, distressed e situazioni speciali verificate.",
    add: "Aggiungi opportunità",
    search: "Cerca per titolo, banca, riferimento o città…",
    allStatuses: "Tutti gli stati",
    allSources: "Tutte le fonti",
    total: "Totale opportunità",
    published: "Pubblicate",
    verified: "Verificate",
    protected: "Commissione protetta",
    price: "Prezzo",
    priceUponRequest: "Prezzo su richiesta",
    deadline: "Scadenza",
    source: "Fonte",
    location: "Località",
    discount: "Sconto stimato",
    verification: "Verifica",
    commission: "Commissione",
    noResults: "Nessuna opportunità bancaria o distressed trovata.",
    notice: "Informazioni d’investimento interne. Verificare tutti i fatti prima della diffusione esterna.",
  },
  ru: {
    navigation: "Банковские и проблемные активы",
    title: "Банковские и проблемные активы",
    subtitle: "Проверенные банковские, проблемные и специальные инвестиционные возможности.",
    add: "Добавить возможность",
    search: "Поиск по названию, банку, номеру или городу…",
    allStatuses: "Все статусы",
    allSources: "Все источники",
    total: "Всего возможностей",
    published: "Опубликованные",
    verified: "Проверенные",
    protected: "Комиссия защищена",
    price: "Цена",
    priceUponRequest: "Цена по запросу",
    deadline: "Срок",
    source: "Источник",
    location: "Местоположение",
    discount: "Расчётная скидка",
    verification: "Проверка",
    commission: "Комиссия",
    noResults: "Банковские или проблемные активы не найдены.",
    notice: "Внутренняя инвестиционная информация. Перед внешним распространением проверьте все факты.",
  },
};

export default bankOpportunityTranslations;
